/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2019 (original work) Open Assessment Technologies SA ;
 */

/**
 * Gets the actual input key
 * @param {KeyboardEvent} event
 * @returns {String}
 */
export function getActualKey(event) {
    const specialKeys = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        19: 'pause',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'insert',
        46: 'delete',
        91: 'meta',
        112: 'f1',
        113: 'f2',
        114: 'f3',
        115: 'f4',
        116: 'f5',
        117: 'f6',
        118: 'f7',
        119: 'f8',
        120: 'f9',
        121: 'f10',
        122: 'f11',
        123: 'f12',
        145: 'scrolllock',
        144: 'numlock'
    };
    // Get the code of the key, used to identify special keys on browser that does not support the full KeyboardEvent API
    const code = event.which || event.keyCode;
    const character = code >= 32 ? String.fromCharCode(code).toLowerCase() : '';

    // Get the name of the key on browser that have a good support of the KeyboardEvent API
    let key = event.key && event.key.toLowerCase();

    // If the browser supports the KeyboardEvent API it may provide the result of the shortcut instead of the actual key.
    // For instance on Mac if you input "Alt+V" the key property will contain "◊"
    const keyName = event.code && event.code.toLowerCase();
    if (keyName) {
        if (keyName.indexOf('key') === 0) {
            // fix the result key only if the actual key name is not alpha (diff due to local layout)
            if (key < 'a' || key > 'z') {
                if (character >= 'a' && character <= 'z') {
                    key = character;
                }
            }
        } else if (keyName.indexOf('digit') === 0) {
            key = keyName.substr(5);
        }
    }

    //return special key map first, if not fallback to one of the other key identification methods
    return specialKeys[code] || key || character;
}
